import { render, staticRenderFns } from "./TabellaRegole.vue?vue&type=template&id=2c7fdce0&scoped=true&"
import script from "./TabellaRegole.vue?vue&type=script&lang=js&"
export * from "./TabellaRegole.vue?vue&type=script&lang=js&"
import style0 from "./TabellaRegole.vue?vue&type=style&index=0&id=2c7fdce0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7fdce0",
  null
  
)

export default component.exports